import { render, staticRenderFns } from "./MgtCategoryList.vue?vue&type=template&id=d661e31e&scoped=true"
import script from "./MgtCategoryList.vue?vue&type=script&lang=js"
export * from "./MgtCategoryList.vue?vue&type=script&lang=js"
import style0 from "./MgtCategoryList.vue?vue&type=style&index=0&id=d661e31e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d661e31e",
  null
  
)

export default component.exports